import {createActions, handleActions, combineActions} from 'redux-actions';
import actions from './recent.actions';

const {recentLoaded} = actions;

const reducer = handleActions(
	{
		[recentLoaded]: (state, {payload}) => [...payload]
	},
	[]
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/recent.reducer.js